import { MAX_LENGTH_BY_CODE_AND_FONT } from "../../max_length_by_code_and_font";
import { FontName, ValidationInput, VariationClassificationCode } from "../../types";

function getVisibleCarvingBlock(scope: HTMLElement, selector: string): HTMLElement | null {
  if (!scope) return null;
  let visibleBlock: HTMLElement | null = null;
  scope.querySelectorAll<HTMLElement>(selector).forEach((block) => {
    if (!block.hidden && !visibleBlock) visibleBlock = block;
  });
  return visibleBlock;
}

/**
 * ValidationInput ビルダー
 * @param inputEl 入力フィールド
 * @returns 正常時は ValidationInput。不正時 / 未完成時は undefined。
 */
export function buildValidationInput(inputEl: HTMLInputElement): ValidationInput | undefined {
  const value = inputEl.value;
  const scope = inputEl.closest<HTMLElement>(".js-validation-scope");
  if (!scope) {
    console.error("Missing validation scope");
    return;
  }

  const fontBlock = getVisibleCarvingBlock(scope, ".js-carving-font-block");
  const checkedOption =
    fontBlock?.querySelector<HTMLInputElement>('[data-validation-part="engraving-font"]:checked') ??
    scope?.querySelector<HTMLInputElement>('[data-validation-part="engraving-font"]:checked');
    if (!checkedOption) {
      if (!scope.querySelector('[data-validation-part="engraving-font"]')) {
        console.error("Missing engraving-font radios in scope");
      }
      return;
    }

  const rawCode = checkedOption.dataset.basketParam;

  if (!rawCode) {
    console.error("Missing variationClassificationCode");
    return;
  }

  if (!(rawCode in MAX_LENGTH_BY_CODE_AND_FONT)) {
    console.error("rawCode not existing in MAX_LENGTH_BY_CODE_AND_FONT");
    return;
  }
  const code = rawCode as VariationClassificationCode;
  
  const rawFont = checkedOption.dataset.basketValue;
  if (!rawFont) {
    console.error("checked font missing data-basket-value");
    return;
  }
  if (!(rawFont in MAX_LENGTH_BY_CODE_AND_FONT[code])) {
    console.error("rawFont not valid for classification code:", rawCode, rawFont);
    return;
  }
  const font = rawFont as FontName;

  return {
    value,
    code,
    font,
  };
}
